module.exports = __webpack_public_path__ + "public/img/img-2.8e5d2817.jpg";